import { useGet } from "@albertine/api-client";
import type { CatalogItemFull } from "@albertine/types/openapi/lmt";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

type WithCatalogItemProps = {
    catalogId: string;
    renderLoading?: React.JSX.Element;
    renderOnError: React.JSX.Element;
    children: (catalogItem: CatalogItemFull) => React.JSX.Element;
};

function WithCatalogItem(props: WithCatalogItemProps) {
    const { catalogId, children, renderLoading, renderOnError } = props;

    const { data, error } = useGet("catalogItemById", { param: { id: catalogId } });

    if (error) {
        return renderOnError;
    }

    const loading = renderLoading || <LoadingSpinner />;

    return data?.catalogItem ? children(data.catalogItem) : loading;
}

export default WithCatalogItem;
